import { Injectable } from '@angular/core';
import { SingleDepartmentService } from '../../../shared/services/single-department.service';

@Injectable({
  providedIn: 'root',
})
export class InjectionMoldingDepartmentService extends SingleDepartmentService {
  override readonly NAME = 'Injection Molding';
  override readonly BRAND = 'daystar';

  private _departmentId: number;
  set departmentId(value: number) {
    this._departmentId = value;
  }
  get departmentId(): number {
    return this._departmentId;
  }

  defaultRoutes(roles: string[]): boolean {
    if (
      roles.includes('InjectionMoldingAdmin') ||
      roles.includes('InjectionMoldingChief')
    ) {
      this.router.navigate(['/sb/injection-molding/planning']);
      return true;
    }
    if (
      roles.includes('InjectionMoldingViewer') ||
      roles.includes('InjectionMoldingOperator') ||
      roles.includes('InjectionMoldingLeader') ||
      roles.includes('InjectionMoldingSupervisor')
    ) {
      this.router.navigate(['/sb/injection-molding/scheduler']);
      return true;
    }
    if (roles.includes('InjectionMoldingLabel')) {
      this.router.navigate(['/sb/injection-molding/packing-box']);
      return true;
    }
    return false;
  }
}
